import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as authReducer from '../app/redirect/reducers/index';
import * as redirectActions from '../app/redirect/redirect.actions';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private store: Store) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(authReducer.selectIsAuth)
            .pipe(
              tap(isAuth => {
                if (!isAuth) {
                  console.log(state.url);
                  this.store.dispatch(redirectActions.authGuardRedirect({data: state.url}));
                  localStorage.setItem('game360redirect', state.url.toString());
                  this.authService.signin();
                } else {
                  localStorage.removeItem('game360redirect');
                }
              })
            );
  }

}
